import {WhitelabelEventWithPayload} from "../../../../common/ts/events/Events";

interface PageWithDfpRightBlockScrolledPayload {
    topSiblingElement: number,
    topSiblingSpacing: number,
    secondDfpBottom: number,
    secondDfpSpacing: number,
    topBoundaryElementBottom: number,
    bottomBoundaryElementBottom: number,
    windowHeight: number
}

export class PageWithDfpRightBlockScrolledEvent implements WhitelabelEventWithPayload<PageWithDfpRightBlockScrolledPayload>{
    payload: PageWithDfpRightBlockScrolledPayload;
    type: string;
    static readonly TYPE: string = 'page-with-dfp-right-block-scrolled';

    constructor(payload: PageWithDfpRightBlockScrolledPayload) {
        this.type = PageWithDfpRightBlockScrolledEvent.TYPE;
        this.payload = payload;
    }
}